import { Styled } from './';

const LoadingDots = () => {
  return (
    <Styled.Snippet>
      <Styled.Stage>
        <Styled.DotFlashing></Styled.DotFlashing>
      </Styled.Stage>
    </Styled.Snippet>
  );
};

export default LoadingDots;
